// Cross-trip preferences, styled to the row at the top of
// "Dashboard - Field Notes.dc.html": a ruled strip with the settings glyph in
// the accent, the label as a kicker, and the current text as an ellipsized
// italic preview.

import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, Settings2 } from "lucide-react";
import { usePreferences } from "@/hooks/use-preferences";

const TravelPreferences = () => {
  const { preferences, setPreferences } = usePreferences();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(preferences);

  // Keep the draft in sync when preferences change elsewhere (another tab,
  // or the landing composer's expander).
  useEffect(() => {
    setDraft(preferences);
  }, [preferences]);

  const commit = () => {
    if (draft !== preferences) setPreferences(draft);
  };

  const preview = preferences.replace(/\s+/g, " ").trim();

  return (
    <div className="border border-rule bg-white">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="w-full flex items-center gap-3 px-[22px] py-4 min-h-[44px] text-left"
      >
        <span className="inline-flex shrink-0">
          <Settings2 className="h-[15px] w-[15px] text-accent" />
        </span>
        <span className="font-sans text-[11px] font-bold uppercase tracking-[0.18em] shrink-0">
          Travel preferences
        </span>
        <span className="font-serif italic text-sm text-ink-faint whitespace-nowrap overflow-hidden text-ellipsis flex-1">
          {preview || "apply to every trip you plan"}
        </span>
        <span className="text-ink-faint inline-flex shrink-0">
          {open ? <ChevronUp className="h-[15px] w-[15px]" /> : <ChevronDown className="h-[15px] w-[15px]" />}
        </span>
      </button>

      {open && (
        <div className="px-[22px] pb-5">
          <textarea
            rows={3}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={commit}
            placeholder="Vegetarian, love coffee shops, prefer walking over taxis, travel with my partner."
            aria-label="Travel preferences"
            // 16px on mobile so iOS does not zoom the page in on focus;
            // the artboard's 15px serif stays at lg.
            className="w-full resize-y border border-rule px-3.5 py-3 font-serif text-[16px] lg:text-[15px] leading-[1.6] bg-paper text-ink placeholder:text-ink-faint outline-none box-border block"
          />
          <p className="font-serif italic text-[11px] text-ink-faint mt-2">
            Saved automatically. The concierge applies these to every new trip.
          </p>
        </div>
      )}
    </div>
  );
};

export default TravelPreferences;
